import { Script } from 'gatsby';
import React from 'react';

const ThirdPartyScripts = () => {
  return (
    <>
      {/* Google Ads */}
      <Script async src="https://www.googletagmanager.com/gtag/js?id=AW-941416228"></Script>
      <Script id="google-ads">{`window.dataLayer = window.dataLayer || []; function gtag(){dataLayer.push(arguments);} gtag('js', new Date()); gtag('config', 'AW-941416228');`}</Script>
    </>
  );
};

export default ThirdPartyScripts;
